{
  "navigation-back-button": {
    "text": {
      "back": "Back",
      "home-page": "Home page"
    }
  }
}
